import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [FormsModule],
  template: `
<div class="container my-5">
  <div class="row justify-content-center">
    <div class="col-md-4">
      <div class="card shadow">
        <div class="card-body p-4">
          <h2 class="text-center mb-4">CMS Login</h2>
          <form (ngSubmit)="onLogin()">
            <div class="mb-3">
              <label class="form-label">Email</label>
              <input type="email" class="form-control" [(ngModel)]="email" name="email" required>
            </div>
            <div class="mb-3">
              <label class="form-label">Password</label>
              <input type="password" class="form-control" [(ngModel)]="password" name="password" required>
            </div>
            @if (error) {
              <div class="alert alert-danger">{{ error }}</div>
            }
            <button type="submit" class="btn btn-primary w-100" [disabled]="loading">
              {{ loading ? 'Signing in...' : 'Login' }}
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
  `
})
export class Login {
  email = '';
  password = '';
  loading = false;
  error = '';

  private authService = inject(AuthService);
  private router = inject(Router);

  async onLogin() {
    this.loading = true;
    this.error = '';
    try {
      await this.authService.login(this.email, this.password);
      this.router.navigate(['/admin']);
    } catch (e: any) {
      this.error = 'Invalid credentials. Please try again.';
      console.error(e);
    } finally {
      this.loading = false;
    }
  }
}
